import { AsyncPipe } from "@angular/common";
import { Component, HostListener, inject, OnDestroy, signal } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CacheService } from "b2b-ecommerce-lib";
import { NgcCookieConsentService } from "ngx-cookieconsent";
import { ButtonDirective, ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";
import { FooterComponent } from "./core/footer/footer.component";
import { HeaderComponent } from "./core/header/header.component";
import { NewVersionCheckerService } from "./services/new-version-checker.service";
import { I18nService } from "./utils/translate.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  imports: [
    RouterOutlet,
    TranslateModule,
    FooterComponent,
    HeaderComponent,
    ToastModule,
    AsyncPipe,
    ButtonDirective,
    ButtonModule,
  ],
})
export class AppComponent implements OnDestroy {
  private readonly _cacheService = inject(CacheService);
  private _newVersionChecker = inject(NewVersionCheckerService);
  toastBreakpoints = {
    "768px": { width: "80%" },
  };
  constructor(
    public I18NService: I18nService,
    public router: Router,
    private ccService: NgcCookieConsentService,
  ) {}

  readonly showButton = signal(false);

  @HostListener("window:scroll", [])
  onScroll() {
    this.showButton.set(window.scrollY > 100);
  }

  scrollTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  ngOnDestroy(): void {
    this._cacheService.destroySub();
  }

  handleSetNewLanguage(language: string) {
    const newLanguage = language.toLowerCase();
    this.I18NService.switchLang(newLanguage);
  }

  confirmUpdate() {
    this._newVersionChecker.applyUpdate();
  }
}
